<canvas [style.display]="hasData ? 'inherit' : 'none'"></canvas>

@if (isLoading) {
    <nw-logo-loading></nw-logo-loading>
}
@if (!isLoading && !hasData) {
    <div class="chart__container__no-data">
        <nw-icon [icon]="icon" class="chart__container__no-data__icon"></nw-icon>
        <div>No Data</div>
    </div>
}
